export const SET_CHANNELS = 'SET_CHANNELS';

export const GET_CHANNELS_REQUEST = 'GET_CHANNELS_REQUEST';
export const GET_CHANNELS_FAILURE = 'GET_CHANNELS_FAILURE';
export const GET_CHANNELS_SUCCESS = 'GET_CHANNELS_SUCCESS';

export const GET_CHANNEL_LINKS_REQUEST = 'GET_CHANNEL_LINKS_REQUEST';
export const GET_CHANNEL_LINKS_FAILURE = 'GET_CHANNEL_LINKS_FAILURE';
export const GET_CHANNEL_LINKS_SUCCESS = 'GET_CHANNEL_LINKS_SUCCESS';

export const SET_SELECTED_CHANNELS = 'SET_SELECTED_CHANNELS';
export const CLEAR_SELECTED_CHANNELS = 'CLEAR_SELECTED_CHANNELS';

export const POLL_FACEBOOK_PAGES_START = 'POLL_FACEBOOK_PAGES_START';
export const POLL_FACEBOOK_PAGES_STOP = 'POLL_FACEBOOK_PAGES_STOP';
export const CLEAR_ADD_FACEBOOK_CHANNEL_STATE = 'CLEAR_ADD_FACEBOOK_CHANNEL_STATE';

export const GET_FACEBOOK_PAGES_REQUEST = 'GET_FACEBOOK_PAGES_REQUEST';
export const GET_FACEBOOK_PAGES_SUCCESS = 'GET_FACEBOOK_PAGES_SUCCESS';
export const GET_FACEBOOK_PAGES_FAILURE = 'GET_FACEBOOK_PAGES_FAILURE';

export const ADD_FACEBOOK_PAGE_REQUEST = 'ADD_FACEBOOK_PAGE_REQUEST';
export const ADD_FACEBOOK_PAGE_SUCCESS = 'ADD_FACEBOOK_PAGE_SUCCESS';
export const ADD_FACEBOOK_PAGE_FAILURE = 'ADD_FACEBOOK_PAGE_FAILURE';

export const POLL_INSTAGRAM_PAGES_START = 'POLL_INSTAGRAM_PAGES_START';
export const POLL_INSTAGRAM_PAGES_STOP = 'POLL_INSTAGRAM_PAGES_STOP';
export const CLEAR_ADD_INSTAGRAM_CHANNEL_STATE = 'CLEAR_ADD_INSTAGRAM_CHANNEL_STATE';

export const GET_INSTAGRAM_PAGES_REQUEST = 'GET_INSTAGRAM_PAGES_REQUEST';
export const GET_INSTAGRAM_PAGES_SUCCESS = 'GET_INSTAGRAM_PAGES_SUCCESS';
export const GET_INSTAGRAM_PAGES_FAILURE = 'GET_INSTAGRAM_PAGES_FAILURE';

export const ADD_INSTAGRAM_CHANNEL_REQUEST = 'ADD_INSTAGRAM_CHANNEL_REQUEST';
export const ADD_INSTAGRAM_CHANNEL_DONE = 'ADD_INSTAGRAM_CHANNEL_DONE';
export const ADD_INSTAGRAM_PAGE_REQUEST = 'ADD_INSTAGRAM_PAGE_REQUEST';
export const ADD_INSTAGRAM_PAGE_SUCCESS = 'ADD_INSTAGRAM_PAGE_SUCCESS';
export const ADD_INSTAGRAM_PAGE_FAILURE = 'ADD_INSTAGRAM_PAGE_FAILURE';

export const ADD_TWITTER_CHANNEL_REQUEST = 'ADD_TWITTER_CHANNEL_REQUEST';
export const ADD_TWITTER_CHANNEL_DONE = 'ADD_TWITTER_CHANNEL_DONE';

export const ADD_EMAIL_CHANNEL_REQUEST = 'ADD_EMAIL_CHANNEL_REQUEST';
export const ADD_EMAIL_CHANNEL_DONE = 'ADD_EMAIL_CHANNEL_DONE';

export const ADD_TIKTOK_CHANNEL_REQUEST = 'ADD_TIKTOK_CHANNEL_REQUEST';
export const ADD_TIKTOK_CHANNEL_DONE = 'ADD_TIKTOK_CHANNEL_DONE';

export const ADD_WECHAT_CHANNEL_REQUEST = 'ADD_WECHAT_CHANNEL_REQUEST';
export const ADD_WECHAT_CHANNEL_DONE = 'ADD_WECHAT_CHANNEL_DONE';

export const ADD_WHATSAPP_CHANNEL_SUCCESS = 'ADD_WHATSAPP_CHANNEL_SUCCESS';
export const ADD_WHATSAPP_CHANNEL_FAILURE = 'ADD_WHATSAPP_CHANNEL_FAILURE';
export const ADD_WHATSAPP_CHANNEL_REQUEST = 'ADD_WHATSAPP_CHANNEL_REQUEST';

export const GET_WHATSAPP_AUTH_CODE_REQUEST = 'GET_WHATSAPP_AUTH_CODE_REQUEST';
export const GET_WHATSAPP_AUTH_CODE_SUCCESS = 'GET_WHATSAPP_AUTH_CODE_SUCCESS';
export const GET_WHATSAPP_AUTH_CODE_FAILURE = 'GET_WHATSAPP_AUTH_CODE_FAILURE';

export const UPDATE_CHANNEL_REQUEST = 'UPDATE_CHANNEL_REQUEST';
export const UPDATE_CHANNEL_SUCCESS = 'UPDATE_CHANNEL_SUCCESS';
export const UPDATE_CHANNEL_FAILURE = 'UPDATE_CHANNEL_FAILURE';

export const GET_TIKTOK_CREATOR_INFO_REQUEST = 'GET_TIKTOK_CREATOR_INFO_REQUEST';
export const GET_TIKTOK_CREATOR_INFO_SUCCESS = 'GET_TIKTOK_CREATOR_INFO_SUCCESS';
export const GET_TIKTOK_CREATOR_INFO_FAILURE = 'GET_TIKTOK_CREATOR_INFO_FAILURE';



// WEBPACK FOOTER //
// ./src/store/modules/channel/mutation-types.js